<template>
   <LazyHeader />
   <FourOhFour />
   <LazyFooter />
</template>

<script setup>
const { error } = defineProps({
   error: Object,
});

useSeoMeta({
   title: "Error - Page Not Found",
});
</script>
